import { Routes, Route, useNavigate } from 'react-router-dom';
import './Error.css';

export function Error(props) {
    return (
        <div className="error_body">
            <section>
                <div className="error_container">
                    {props.type === 'browser' ? <div className="error_text">
                            <h1>Your browser is not supported</h1>
                            <p>This app is currently not supported on your browser. Please use edge or chrome.</p>
                            {/* <div class="input-box">
                                <input type="text" id="input-box" placeholder="Search..." autocomplete="off">
                            </div>
                            <div class="result-box"></div> */}
                            <ul className="error_menu">
                                {/* <li><a href="#">Visit our Blog</a></li> */}
                                <li><a href="#">Contact support</a></li>
                            </ul>
                        </div> 
                        : 
                        (props.type === 'page') 
                        ?
                        <div className="error_text">
                            <h1>Page not found</h1>
                            <p>The page you are looking for does not exist</p>
                            {/* <div class="input-box">
                                <input type="text" id="input-box" placeholder="Search..." autocomplete="off">
                            </div>
                            <div class="result-box"></div> */}
                            <ul className="error_menu">
                                <li><a href="/">Go to Homepage</a></li>
                                {/* <li><a href="#">Visit our Blog</a></li> */}
                                <li><a href="#">Contact support</a></li>
                            </ul>
                        </div>
                        :
                        <div className="error_text">
                            <h1>Our app is not supported on your device</h1>
                            <p>We are currently working on a mobile version of this site. For better experience, please use a desktop computer or tablet.</p>
                            {/* <div class="input-box">
                                <input type="text" id="input-box" placeholder="Search..." autocomplete="off">
                            </div>
                            <div class="result-box"></div> */}
                            <ul className="error_menu">
                                {/* <li><a href="#">Visit our Blog</a></li> */}
                                <li><a href="#">Contact support</a></li>
                            </ul>
                        </div> 
                    }
                    <div><img className="error_image" src="https://omjsblog.files.wordpress.com/2023/07/errorimg.png" alt=""/></div>
                </div>
            </section>
        </div>
    );
}
